var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_data_check_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_data_check_icon)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,2.5L2.5,13.5L13.5,13.5L13.5,2.5L2.5,2.5ZM3.5,3.5L12.5,3.5L12.5,12.5L3.5,12.5L3.5,3.5ZM4.5,4.5L4.5,11.5L11.5,11.5L11.5,4.5L4.5,4.5ZM5.5,5.5L5.5,6.5L10.5,6.5L10.5,5.5L5.5,5.5ZM5.5,7.5L5.5,8.5L10.5,8.5L10.5,7.5L5.5,7.5ZM5.5,9.5L5.5,10.5L8.5,10.5L8.5,9.5L5.5,9.5Z",
    fillRule: "evenodd",
    fill: "#a277ee",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataActive);
export default __webpack_public_path__ + "static/media/icon-data-active.d060d6bf591947b32988cc6089b00968.svg";
export { ForwardRef as ReactComponent };